// Import will be used when implementing actions
// import { dashboardApi } from '@/services/api'

// Initial state
const state = {
  stats: null,
  recentActivity: [],
  loading: false,
  error: null
}

// Getters
const getters = {
  stats: state => state.stats,
  recentActivity: state => state.recentActivity,
  isLoading: state => state.loading,
  error: state => state.error
}

// Mutations
const mutations = {
  SET_STATS(state, stats) {
    state.stats = stats
  },
  SET_RECENT_ACTIVITY(state, activity) {
    state.recentActivity = activity
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

// Actions
const actions = {
  // Will be implemented as needed
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
} 